import './SensorDataDisplay.css';
import React from 'react'
import { COLORS } from '../LineChart/Consts/LineChartConsts';

class SensorDataDisplay extends React.Component {
	renderValue({desktop, mobile, sup, prefixClassName, color}) {
		return (
			<div 
				className='sensor-data-display__value'
				data-desktop-value={desktop}
				data-mobile-value={mobile}
				style={{color}}
			>
				{/* <span className={prefixClassName}/>	 */}
				<span className="sensor-data-display__value-sup">{sup}</span>
			</div>
		)
	}
	
	getValue(value) {
		const fixedValue = this.props.live ? value : null;

		return fixedValue || '–';
	}

	render() {
		const temp = this.getValue(this.props.temp);
		const ppm = this.getValue(this.props.ppm); 
		const rh = this.getValue(this.props.rh);

		return (
			<div className="sensor-data-display">
				{ this.renderValue({
					desktop: `Temp: ${temp}°C`,
					mobile: `${temp}`,
					sup: '°C',
					color: COLORS.RED
				}) }
				{ this.renderValue({
					desktop: `RH: ${rh}%`,
					mobile: `${rh}`,
					sup: '%RH',
					color: COLORS.YELLOW
				}) }
				{ this.renderValue({
					desktop: `: ${ppm}PPM`,
					mobile: `${ppm}`,
					sup: 'PPM',
					color: COLORS.BLUE,
					prefixClassName: 'sensor-data-display--co-2'
				}) }
				<div className={`sensor-data-display__live-dot ${this.props.live ? 'sensor-data-display__live-dot--live' : ''}`}/>
			</div>
		)
	}
}

SensorDataDisplay.defaultProps = {
	rh: null,
	ppm: null,
	temp: null,
	live: false
}
// TODO this component should not get -1 -273 or ppm <400

export default SensorDataDisplay;